/* Nood-Kit.nl — interactions (reveal, counters, checklist, calculator, delivery countdown, sticky ATC) */
(function () {
  'use strict';

  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---------- Reveal on scroll ---------- */
  var revealObserver =
    'IntersectionObserver' in window
      ? new IntersectionObserver(
          function (entries) {
            entries.forEach(function (entry) {
              if (!entry.isIntersecting) return;
              entry.target.classList.add('is-visible');
              revealObserver.unobserve(entry.target);
            });
          },
          { rootMargin: '0px 0px -8% 0px', threshold: 0.08 }
        )
      : null;

  function initReveal(root) {
    root.querySelectorAll('[data-nk-reveal]:not(.is-visible)').forEach(function (el) {
      if (!revealObserver || reduceMotion) return el.classList.add('is-visible');
      revealObserver.observe(el);
    });
  }

  /* ---------- Animated counters ---------- */
  function formatNumber(n, decimals) {
    return n.toLocaleString('nl-NL', { minimumFractionDigits: decimals, maximumFractionDigits: decimals });
  }

  function animateCount(el) {
    var target = parseFloat(el.getAttribute('data-nk-count'));
    if (isNaN(target)) return;
    var decimals = parseInt(el.getAttribute('data-nk-decimals') || '0', 10);
    if (reduceMotion) return (el.textContent = formatNumber(target, decimals));
    var duration = 1600;
    var start = null;
    function step(ts) {
      if (!start) start = ts;
      var p = Math.min((ts - start) / duration, 1);
      var eased = 1 - Math.pow(1 - p, 3);
      el.textContent = formatNumber(target * eased, decimals);
      if (p < 1) requestAnimationFrame(step);
    }
    requestAnimationFrame(step);
  }

  function initCounters(root) {
    var els = root.querySelectorAll('[data-nk-count]:not([data-nk-counted])');
    if (!els.length) return;
    var io = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          entry.target.setAttribute('data-nk-counted', '');
          animateCount(entry.target);
          io.unobserve(entry.target);
        });
      },
      { threshold: 0.4 }
    );
    els.forEach(function (el) {
      io.observe(el);
    });
  }

  /* ---------- Checklist: tick items one by one when visible ---------- */
  function initChecklist(root) {
    var groups = root.querySelectorAll('[data-nk-checkgroup]:not([data-nk-ready])');
    if (!groups.length) return;
    var io = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          io.unobserve(entry.target);
          var items = entry.target.querySelectorAll('[data-nk-check="in"]');
          items.forEach(function (item, i) {
            setTimeout(function () {
              item.classList.add('is-checked');
            }, reduceMotion ? 0 : 250 + i * 220);
          });
        });
      },
      { threshold: 0.35 }
    );
    groups.forEach(function (g) {
      g.setAttribute('data-nk-ready', '');
      io.observe(g);
    });
  }

  /* ---------- Water / food calculator ---------- */
  function initCalculator(root) {
    root.querySelectorAll('[data-nk-calc]:not([data-nk-ready])').forEach(function (calc) {
      calc.setAttribute('data-nk-ready', '');
      var output = calc.querySelector('[data-nk-calc-persons]');
      var water = calc.querySelector('[data-nk-calc-water]');
      var days = parseInt(calc.getAttribute('data-days') || '3', 10);
      var litres = parseFloat(calc.getAttribute('data-litres') || '3');
      var persons = parseInt(output.textContent, 10) || 2;

      function render() {
        output.textContent = persons;
        water.textContent = formatNumber(persons * litres * days, 0);
        calc.querySelectorAll('[data-nk-calc-bottles]').forEach(function (el) {
          el.textContent = formatNumber(Math.ceil((persons * litres * days) / 1.5), 0);
        });
        calc.querySelectorAll('[data-nk-calc-meals]').forEach(function (el) {
          el.textContent = formatNumber(persons * days * 3, 0);
        });
      }

      calc.querySelectorAll('[data-nk-calc-step]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          persons = Math.max(1, Math.min(12, persons + parseInt(btn.getAttribute('data-nk-calc-step'), 10)));
          render();
        });
      });
      render();
    });
  }

  /* ---------- Delivery countdown (Europe/Amsterdam) ---------- */
  var DAYS = ['zondag', 'maandag', 'dinsdag', 'woensdag', 'donderdag', 'vrijdag', 'zaterdag'];

  function amsterdamNow() {
    try {
      var parts = new Intl.DateTimeFormat('en-GB', {
        timeZone: 'Europe/Amsterdam',
        weekday: 'short',
        hour: '2-digit',
        minute: '2-digit',
        second: '2-digit',
        hour12: false,
      }).formatToParts(new Date());
      var map = {};
      parts.forEach(function (p) {
        map[p.type] = p.value;
      });
      var wd = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'].indexOf(map.weekday);
      return { day: wd, h: parseInt(map.hour, 10) % 24, m: parseInt(map.minute, 10), s: parseInt(map.second, 10) };
    } catch (e) {
      var d = new Date();
      return { day: d.getDay(), h: d.getHours(), m: d.getMinutes(), s: d.getSeconds() };
    }
  }

  function relativeDay(offset, targetDay) {
    if (offset === 0) return 'vandaag';
    if (offset === 1) return 'morgen';
    return DAYS[targetDay];
  }

  function updateDelivery(el) {
    var cutoff = parseInt(el.getAttribute('data-cutoff') || '16', 10);
    var saturday = el.getAttribute('data-saturday') === 'true';
    var now = amsterdamNow();
    var isShipDay = now.day >= 1 && now.day <= 5;
    var beforeCutoff = now.h < cutoff;
    var textEl = el.querySelector('[data-nk-delivery-text]');
    if (!textEl) return;

    if (isShipDay && beforeCutoff) {
      var secsLeft = (cutoff - now.h) * 3600 - now.m * 60 - now.s;
      var hrs = Math.floor(secsLeft / 3600);
      var mins = Math.floor((secsLeft % 3600) / 60);
      var deliveryDay = (now.day + 1) % 7;
      var offset = 1;
      if (deliveryDay === 6 && !saturday) { deliveryDay = 1; offset = 3; }
      if (deliveryDay === 0) { deliveryDay = 1; offset = 2; }
      textEl.innerHTML =
        'Bestel binnen <span data-nk-countdown>' + (hrs > 0 ? hrs + 'u ' : '') + mins + 'm</span> en ontvang het <strong>' +
        relativeDay(offset, deliveryDay) + '</strong>.';
      return;
    }

    // Next shipping day
    var shipOffset = 1;
    var shipDay = (now.day + 1) % 7;
    while (shipDay === 0 || shipDay === 6) {
      shipOffset++;
      shipDay = (shipDay + 1) % 7;
    }
    var delOffset = shipOffset + 1;
    var delDay = (shipDay + 1) % 7;
    if (delDay === 6 && !saturday) { delOffset += 2; delDay = 1; }
    if (delDay === 0) { delOffset += 1; delDay = 1; }
    textEl.innerHTML =
      'Nu besteld = <strong>' + relativeDay(shipOffset, shipDay) + '</strong> verzonden, <strong>' +
      relativeDay(delOffset, delDay) + '</strong> in huis.';
  }

  function initDelivery(root) {
    root.querySelectorAll('[data-nk-delivery]').forEach(function (el) {
      updateDelivery(el);
      if (!el.hasAttribute('data-nk-ready')) {
        el.setAttribute('data-nk-ready', '');
        setInterval(function () {
          updateDelivery(el);
        }, 30000);
      }
    });
  }

  /* ---------- Horizontal track navigation (reviews) ---------- */
  function initTracks(root) {
    root.querySelectorAll('[data-nk-track]:not([data-nk-ready])').forEach(function (wrap) {
      wrap.setAttribute('data-nk-ready', '');
      var track = wrap.querySelector('[data-nk-track-list]');
      if (!track) return;
      wrap.querySelectorAll('[data-nk-track-dir]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          var dir = parseInt(btn.getAttribute('data-nk-track-dir'), 10);
          var card = track.firstElementChild;
          var amount = card ? card.getBoundingClientRect().width + 20 : track.clientWidth * 0.8;
          track.scrollBy({ left: dir * amount, behavior: reduceMotion ? 'auto' : 'smooth' });
        });
      });
    });
  }

  /* ---------- Sticky add to cart ---------- */
  function initStickyAtc(root) {
    var bar = root.querySelector('[data-nk-sticky-atc]');
    if (!bar || bar.hasAttribute('data-nk-ready')) return;
    bar.setAttribute('data-nk-ready', '');
    var sectionId = bar.getAttribute('data-section');
    var mainBtn = document.querySelector('#ProductSubmitButton-' + sectionId);
    if (!mainBtn) return;
    document.body.classList.add('nk-has-sticky-atc-page');

    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        var show = !entry.isIntersecting && entry.boundingClientRect.top < 0;
        bar.classList.toggle('is-visible', show);
        bar.setAttribute('aria-hidden', show ? 'false' : 'true');
        document.body.classList.toggle('nk-has-sticky-atc', show);
      });
    });
    io.observe(mainBtn);

    var stickyBtn = bar.querySelector('[data-nk-sticky-btn]');
    stickyBtn.addEventListener('click', function () {
      if (mainBtn.disabled) {
        mainBtn.scrollIntoView({ behavior: 'smooth', block: 'center' });
        return;
      }
      mainBtn.click();
    });

    // keep sold-out state in sync with the main button
    var sync = function () {
      stickyBtn.disabled = mainBtn.disabled;
      var label = mainBtn.querySelector('span');
      if (label) stickyBtn.querySelector('span').textContent = label.textContent.trim();
    };
    new MutationObserver(sync).observe(mainBtn, { attributes: true, childList: true, subtree: true });
    sync();
  }

  /* ---------- Mobile kit carousel: start on the featured kit ---------- */
  function initKitCarousel(root) {
    root.querySelectorAll('.nk-kits__grid:not([data-nk-ready])').forEach(function (grid) {
      grid.setAttribute('data-nk-ready', '');
      if (grid.scrollWidth <= grid.clientWidth) return;
      var featured = grid.querySelector('.nk-kit--featured');
      if (!featured) return;
      grid.scrollLeft = featured.offsetLeft - (grid.clientWidth - featured.offsetWidth) / 2;
    });
  }

  /* ---------- Boot ---------- */
  function init(root) {
    root = root || document;
    initReveal(root);
    initCounters(root);
    initChecklist(root);
    initCalculator(root);
    initDelivery(root);
    initTracks(root);
    initStickyAtc(root);
    initKitCarousel(root);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      init(document);
    });
  } else {
    init(document);
  }

  document.addEventListener('shopify:section:load', function (e) {
    init(e.target);
  });
})();
